import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.css'
})
export class BlogDetailsComponent implements OnInit {

  blogId: string = '';
  blog: any;
  resultLoaded: boolean = false;

  constructor(private _apiService : ApiService,
      private route: ActivatedRoute,
      private router: Router
    ){
      
    }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      console.log(params);
      this.blogId = params.get('id') || '';
    
      this._apiService.getBlogDetails(this.blogId).subscribe((res) => {
        this.blog = res.data;
        this.resultLoaded = true;
      });
    });
  }
}
